module.exports = __webpack_public_path__ + "static/media/image001.d6ade7d4.jpg";